import React, { useState, useEffect, useRef } from 'react';

// Placeholder en base64 (petit carré gris) - ne peut jamais échouer
const INLINE_PLACEHOLDER = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2UwZTBlMCIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1zaXplPSIxNCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzk5OSI+SW1hZ2U8L3RleHQ+PC9zdmc+';

/**
 * Composant Image avec gestion automatique des erreurs de chargement
 * Affiche un placeholder si l'image ne peut pas être chargée
 * Utilise un placeholder inline SVG pour éviter toute boucle infinie
 */
const ImageWithFallback = ({
  src,
  alt,
  fallback = '/img/pro/default.png',
  className = '',
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(src || fallback);
  const errorCountRef = useRef(0);

  const handleError = () => {
    errorCountRef.current += 1;

    // Première erreur: essayer le fallback
    if (errorCountRef.current === 1 && imgSrc !== fallback) {
      setImgSrc(fallback);
    }
    // Deuxième erreur (fallback a aussi échoué): utiliser le placeholder inline
    else if (errorCountRef.current >= 2) {
      setImgSrc(INLINE_PLACEHOLDER);
    }
  };

  // Si src change, réinitialiser
  useEffect(() => {
    errorCountRef.current = 0;
    setImgSrc(src || fallback);
  }, [src, fallback]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;
